import React from 'react';
import { Link } from 'react-router-dom';

const SiteList = ({ token, sites}) => {
  if (!token) {
    return (<h2>Please login to view your sites. <Link to={'/login'} className="btn btn-primary">Sign In</Link></h2>);
  }

  if(sites) {
    sites = sites.sort((a, b) => {
      return (a.modifiedAt > b.modifiedAt ? -1 : 1);
    });
  }

  const SiteView = props => {
    return (
      <div className="card" style={{margin: '10px', padding: '10px', maxWidth: '350px', boxShadow: '0 3px 10px rgba(0,0,0,0.1)', display: 'inline-block'}}>
        <img className="card-img-top" style={{marginBottom: '10px', maxHeight: '250px', maxWidth: '250px', borderRadius: '100%'}} src={'https://dearinvite.com/'+props.site.couplePhoto} alt="Image"></img>
        <div className="card-body">
          <h5 className="card-title"><a href={'https://dearinvite.com/sites/'+props.site.id} target="_blank">{props.site.groom} & {props.site.bride}</a></h5>
          <div className="card-text">
            Template: {props.site.template}<br/>
            Wedding Location: {props.site.weddingLocation}<br/>
            Wedding Time: {props.site.weddingDatetime}<br/>
            <Link to={'/sites/'+props.site.id+'/edit'} className="btn btn-primary">Edit</Link>&nbsp;
            <Link to={'/sites/'+props.site.id+'/view'} className="btn btn-primary">View</Link>&nbsp;
            <a href={'https://dearinvite.com/sites/'+props.site.id} target="_blank">Preview</a>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="col-md-9">
      {token && sites &&  
        <div>
          <h5>{sites.length} active site(s)</h5>
          {/* <div className="feed-toggle">
            <input type="text" placeholder="Search for sites by name or location" className="form-control form-control-lg"/>
          </div> */}
          <br/>
          {sites.map((site) => <SiteView key={site.id} site={site}/> )}
        </div>
      }
    </div>
  );

};

export default SiteList;
